export enum IntegrationKey {
  RealSatisfied = 'realsatisfied',
  SellersShield = 'sellersshield',
  UtilityConnect = 'utilityconnect',
}

export enum EnablementStatus {
  Active = 'active',
  Inactive = 'inactive',
  Pending = 'pending',
}

export type IntegrationEnablement = {
  enabled: boolean;
  optInAvailable: boolean;
  userEnablement: EnablementStatus;
  brokerEnablement: EnablementStatus;
  serviceStatus?: {
    status: string;
    message?: string;
    code?: number;
  };
  /** Controls when and how integration prompts are shown to users based on their history and preferences */
  promptEligibility?: {
    /** Determines if the UI should display a prompt based on timing, opt-out status, and previous interactions */
    isEligible: boolean;
    /** Explains the eligibility decision with detailed context for debugging and analytics purposes */
    reason: string;
    /** The number of times the user has dismissed the integration prompt */
    dismissCount?: number;
  };
  /** Indicates if broker has enforced this integration for all users (forced opt-in) */
  brokerRequired?: boolean;
};

export type IntegrationsResponse = Partial<{
  [key in IntegrationKey]: IntegrationEnablement;
}>;
